import styled from 'styled-components'

import { appearWithPosition } from '../../constants/animations'
import { H5 } from '../texts'

const TooltipContainer = styled.div`
  position: fixed;
  text-align: center;
  max-width: ${props => props.tooltipWidth || 320}px;
  max-height: 450px;
  width: ${props => (props.picture ? 320 : props.tooltipWidth)}px;
  padding: ${props => !props.picture && !props.hotKey && props.size !== 'small' && '8px 30px'};
  box-shadow: ${props => props.theme.shadow.xl};
  background: ${props => props.theme.color.backgroundRush};
  border-radius: 15px;
  z-index: 99999;
  pointer-events: none;

  &, * {
    box-sizing: border-box;
  }
  
  top: ${p =>
    p.position === 'bottom'
      ? `${p.targetBottom}px`
      : p.targetTop - (p.position === 'top' ? p.height + 20 : p.height / 2) < 0
        ? `${2 + (p.position === 'top' ? 20 : 0)}px`
        : p.position === 'top'
          ? `${p.targetTop - p.height}px`
          : p.targetTop + (p.tooltipHeght + p.height) / 2 > window.innerHeight
            ? `${window.innerHeight - p.height - 2}px`
            : `${p.targetTop + p.targetHeight / 2 - p.height / 2}px`
  };

  left: ${p =>
    p.position === 'right'
      ? `${p.targetRight}px`
      : p.targetLeft - (p.position === 'left' ? p.width + 20 : p.width / 2) < 0
        ? `${2 + (p.position === 'left' ? 20 : 0)}px`
        : p.position === 'left'
          ? `${p.targetLeft - p.width}px`
          : p.targetLeft + (p.tooltipWidth + p.width) / 2 > window.innerWidth
            ? `${window.innerWidth - p.width - 2}px`
            : `${p.targetLeft + p.targetWidth / 2 - p.width / 2}px`
  };

  transform: ${props =>
    props.position === 'top'
      ? 'translate(0, -20px)'
      : props.position === 'bottom'
        ? 'translate(0, 20px)'
        : props.position === 'left'
          ? 'translate(-20px, 0)'
          : 'translate(20px, 0)'};

  animation-delay: ${p => (p.speed ? p.theme.duration[p.speed] : '0s')};

  animation-name: ${p => appearWithPosition(p.position, 0, -20)};
  animation-duration: ${p => p.theme.duration.m};
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;

  img {
    border-radius: 15px 15px 0 0;
    height: 180px;
    width: 320px;
    display: flex;
  }
  opacity: ${p => p.isTranslucent ? 0.5 : 1} ${p => p.isTranslucent && '!important'};
`

const HotKeyContainer = styled.div`
  height: 40px;
  width: 40px;
  border: 2px solid ${p => p.theme.color.turquoise};
  border-radius: 10px;
  display: flex;
  justify-content: center;
`

const DescriptionContainer = styled.div`
  padding: 0 30px 30px 30px;
`

const TextWithHotKey = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  padding: 0 30px;
  & > ${H5} {
    padding-right: ${p => !p.picture && '20px'};
  }
`

const Header = styled.div`
  display: ${p => p.description ? 'block' : 'flex'};
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  padding-bottom: ${p => p.description ? 10 : 20}px;
  border-bottom: ${p => p.description ? `10px solid ${p.theme.color.pale}` : 'none'};
`;

const Hotkey = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: ${p => p.description ? '5px 0 0 0' : '0 0 0 10px'};

  p {
    min-width: 20px;
    padding: 4px 5px 2px 5px;
    text-align: center;
    line-height: 14px;
    border-radius: 5px;
    background: ${p => p.theme.color.turquoise};
  }
`;

const Description = styled.div`
  padding: 20px;
  padding-top: 10px;
`;

export const Styled = {
  TooltipContainer,
  HotKeyContainer,
  DescriptionContainer,
  TextWithHotKey,
  Header,
  Hotkey,
  Description,
};
